import { faFilePdf, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import NorthIcon from "@mui/icons-material/North";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SouthIcon from "@mui/icons-material/South";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import GetAppIcon from "@material-ui/icons/GetApp";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import {
  getHumanReadableDate,
  getRequest,
  postRequest,
} from "../../globalhelper/helper";
import VR2_Forms from "../../pages/VR2_Form_Rendering/displayContainer";
import "../CI/COD.css";
import "./Modal.css";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Drawer,
  Grid,
  IconButton,
  Pagination,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  Tooltip,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";
import { useDispatch } from "react-redux";
import { hideLoader, showLoader } from "../../redux/Common/commonActions";
import { GetApp } from "@material-ui/icons";

const BulkApprovals = (props) => {
  let dispatch = useDispatch();
  const screenName = localStorage.getItem("pageName");
  const [formData, setFormData] = useState({
    transtype: "",
    fromDate: "",
    toDate: "",
    company: "",
    email: "",
    transstatus: "",
    csvDownloaded: "",
    name: "",
    activitystatus: "",
    createdid: "",
  });
  const [disableBtn, setDisableBtn] = useState(false);

  const TransactionTypes = [
    "BillExtract",
    "GoodsAndServicesEntries",
    "ItemPreferences",
    "ItemMaster",
    "PurchaseOrder",
    "VendorMaster",
    "VendorPreferences",
    // 'CreditCard',
    // 'DigitalWalletAccounting',
    // 'EmployeeCost',
    // 'EmployeeCostFnF',
    // 'EmployeeCostAccruedReversal',
    // 'EmployeeReimbursement',
    // 'InstructorAccrualReversal',
    // 'InstructorCostAccrual',
    // 'InstructorInvoice',
    "VendorAdvancePayment",
    "Payment",
    "PettyCash",
  ];

  const [statusOptions, setStatusOption] = useState([]);
  const [Name, setName] = useState([]);
  const [LinkRef, setLinkRef] = useState([]);
  const [createdIds, setCreatedID] = useState([]);
  const [ActivityStatus, setActivityStatus] = useState([]);
  const [allActivityCodes, setAllActivityCodes] = useState([]);
  const [companyName, setCompanyName] = useState([]);
  const [companyDetails, setCompanyDetails] = useState([]);
  const [loading, setLoading] = useState(false);
  const [queryResult, setQueryResult] = useState([]);
  const [qresult, setQResult] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedRowData, setSelectedRowData] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [activityCode, setActivityCode] = useState([]);
  const [showError, setShowError] = useState(false);
  const [warningMessage, setWarningMessage] = useState("");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [showScrollButton, setShowScrollButton] = useState(false);
  const [isBillType, setIsBillType] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [redirectBill, setRedirectBill] = useState(false);
  const [searchJSON, setSearchJSON] = useState(null);
  const [UserInputdetails, setUserInputdetails] = useState({});
  const [pdfUrl, setPdfUrl] = useState(null);
  const [activePdf, setActivePdf] = useState(null);
  const [isFormVisible, setIsFormVisible] = useState(true);
  const [downloadedItems, setDownloadedItems] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [rejectionReason, setRejectionReason] = useState("");
  const [approvalStatus, setApprovalStatus] = useState("");
  const [cdata, setcdata] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [filteredResults, setFilteredResults] = useState([]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  useEffect(() => {
    getRequest(`api/edureka/getCompanyAssignedToUser`)
      .then((response) => {
        console.log(response.res.data);
        const responseData = response.res.data;
        const orgname = responseData.map((item) => item.orgname);
        setCompanyDetails(responseData);
        setCompanyName(orgname);
        if (orgname.length === 1) {
          handleChange("company", orgname[0]);
        }
        var currentDate = moment();
        var firstDay = currentDate.startOf("month").format("YYYY-MM-DD");
        var lastDay = currentDate.endOf("month").format("YYYY-MM-DD");
        setFormData((prev) => {
          return { ...prev, fromDate: firstDay, toDate: lastDay };
        });
        const companyid = responseData.map((item) => item.orgid);
        console.log("companyid", companyid);
        const COD = companyid.sort();
        console.log("COD", COD);
        const CID = companyid[0];
        console.log("CID", CID);

        getRequest(`api/edureka/getUserInputFE?orgID=${CID}&page=${screenName}`)
          .then((response) => {
            const userdata = response.res.data?.Item || [];
            console.log("USERDTA", userdata);
            if (userdata) {
              setUserInputdetails(userdata);
              let company = responseData.find(
                (det) => userdata.orgId[0] == det.orgid
              );

              setFormData((prev) => ({
                ...prev,
                company: company?.orgname || "",
                fromDate: userdata.forprdfrom || "",
                toDate: userdata.forprdto || "",
                transtype: userdata.type || "",
              }));
            }
          })
          .catch((err) => console.log(err));
      })
      .catch((err) => console.log(err));
    getRequest(`api/edureka/getVendorActivityCode`)
      .then((res) => {
        console.log(res.res.data);
        setAllActivityCodes(res.res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    setIsBillType(formData.transtype === "BillExtract" ? true : false);
  }, [formData.transtype]);

  const handleChange = (name, value) => {
    setFormData((prev) => {
      return { ...prev, [name]: value };
    });
  };

  const getPdf = async (pdfloc) => {
    const id = companyDetails.filter(
      (item) => item.orgname === formData.company
    );
    const companyid =
      id.length > 0 ? id.map((item) => item.orgid)[0] : UserInputdetails.orgId;
    console.log("COMPANYID", companyid);

    postRequest(`api/edureka/getThePdf?pdfloc=${pdfloc}&orgID=${companyid}`)
      .then((response) => {
        console.log("R", response);
        const bufferData = response.res.data.data;
        console.log("BD", bufferData);
        const byteArray = new Uint8Array(bufferData);
        const pdfBlob = new Blob([byteArray], { type: "application/pdf" });
        const url = URL.createObjectURL(pdfBlob);
        setPdfUrl(url);
        setActivePdf(pdfloc);
        setIsFormVisible(false);
      })
      .catch((error) => {
        console.error("Error fetching PDF:", error);
      });
  };

  const closeModal = () => {
    setPdfUrl(null);
    setActivePdf(null);
  };

  const handleSubmit = () => {
    setSelectedItems([]);
    setSelectedRowData([]);
    setSelectAll(false);
    setFormData((prev) => ({
      ...prev,
      name: "",
      activitystatus: "",
      transstatus: "",
      createdid: "",
    }));
    dispatch(showLoader());
    const id = companyDetails.filter(
      (item) => item.orgname === formData.company
    );
    const companyid =
      id.length > 0 ? id.map((item) => item.orgid) : UserInputdetails.orgId;
    console.log("COMPANYID", companyid);

    const item = {
      forprdfrom: formData.fromDate,
      forprdto: formData.toDate,
      type: formData.transtype,
      orgid: companyid,
      email: formData.email,
      transstatus: formData.transstatus,
      page: screenName,
    };

    setLoading(true);
    setShowError(false);

    postRequest(`api/edureka/getBulkApprovals`, item)
      .then((response) => {
        console.log(response.res.data);
        const res = response.res.data;
        if (!res.length || res.length === 0) {
          console.log("Entered");
          setShowError(true);
          setWarningMessage("No data found, please try some other combination");
          return;
        }
        let Status = [...new Set(res.map((item) => item.status))].filter(
          (data) => data
        );
        let ActivityStatus = [
          ...new Set(res.map((item) => item.activitystatus)),
        ].filter((data) => data);
        let Name = [...new Set(res.map((item) => item.Name))].filter(
          (data) => data
        );
        let LinkRef = [
          ...new Set(res.map((item) => item?.["Link Ref"])),
        ].filter((data) => data);
        let CreatedID = [...new Set(res.map((item) => item.createdid))].filter(
          (data) => data
        );
        console.log(ActivityStatus);

        setCreatedID(CreatedID);
        setStatusOption(Status);
        setName(Name);
        setLinkRef(LinkRef);
        setActivityStatus(ActivityStatus);
        const billNumbers = res.map((item) => item.createdid);
        const field = formData.transstatus
          ? formData.transstatus
          : "Waiting For Approval";
        const filteredData = res.filter(
          (item) => item.activitystatus === field
        );

        const newDownloadedItems = {};
        filteredData.forEach((item) => {
          if (item["activitystatus"] === "Active") {
            newDownloadedItems[item["createdid"]] = {
              downloaded: false,
              timestamp: "",
            };
          }
        });

        console.log(newDownloadedItems);
        console.log(filteredData, res);

        // Merge with previously downloaded data
        setDownloadedItems((prev) => ({ ...prev, ...newDownloadedItems }));

        setQResult(filteredData);
        setFilteredResults(
          res.sort((a, b) => a["createdid"].localeCompare(b["createdid"]))
        );

        setQueryResult(
          res.sort((a, b) => a["createdid"].localeCompare(b["createdid"]))
        );

        setLoading(false);
        setActivityCode([...new Set(billNumbers)]);

        // if (formData.transtype === 'Payment') {
        //   // Fetch downloaded Status and timestamp for the createdids in queryResult
        //   const createdIds = res.map(item => item['createdid'])
        //   console.log(`api/edureka/getDownloadedItemsByCreatedIds`, {
        //     createdIds
        //   })
        //   postRequest(`api/edureka/getDownloadedItemsByCreatedIds`, {
        //     createdIds
        //   })
        //     .then(downloadResponse => {
        //       // console.log('Raw download response:', downloadResponse);

        //       // Ensure response format is correct
        //       if (
        //         downloadResponse &&
        //         downloadResponse.res &&
        //         downloadResponse.res.data
        //       ) {
        //         const downloadedData = downloadResponse.res.data
        //         console.log('Parsed download data:', downloadedData)

        //         // Initialize updatedDownloadedItems
        //         const updatedDownloadedItems = {}

        //         // Decode response data
        //         downloadedData.length > 0 &&
        //           Object.keys(downloadedData).forEach(createdId => {
        //             const item = downloadedData[createdId]
        //             updatedDownloadedItems[createdId] = {
        //               downloaded: item.downloaded,
        //               timestamp: item.timestamp
        //             }
        //           })

        //         // Set the state with the decoded data
        //         setDownloadedItems(updatedDownloadedItems)
        //       } else {
        //         console.error('Unexpected response format:', downloadResponse)
        //       }
        //     })
        //     .catch(err => {
        //       console.error('Error in postRequest:', err)
        //     })
        // } else {
        //   console.log(Error)
        // }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      })
      .finally(() => dispatch(hideLoader()));
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedItems([]);
      setSelectedRowData([]);
    } else {
      if (
        formData.transtype === "BillExtract" ||
        formData.transtype === "GoodsAndServicesEntries" ||
        formData.transtype === "ItemPreferences" ||
        formData.transtype === "ItemMaster" ||
        formData.transtype === "PurchaseOrder" ||
        formData.transtype === "VendorMaster" ||
        formData.transtype === "VendorPreferences" ||
        formData.transtype === "Payment" ||
        formData.transtype === "VendorAdvancePayment" ||
        formData.transtype === "PettyCash"
      ) {
        const selectedRows = (
          rowsPerPage > 0
            ? filteredResults.slice(
              page * rowsPerPage,
              page * rowsPerPage + rowsPerPage
            )
            : filteredResults
        ).map((item, index) => item["createdid"]);
        const deDuplicatedArray = [...new Set(selectedRows)];
        console.log(deDuplicatedArray);
        setSelectedItems(deDuplicatedArray);
        setSelectedRowData(deDuplicatedArray);
      } else {
        const filteredColumns = queryResult.filter(
          (item) => item.status === "Yes" || item.status === "No"
        );
        const selectedRows = (
          rowsPerPage > 0
            ? filteredResults.slice(
              page * rowsPerPage,
              page * rowsPerPage + rowsPerPage
            )
            : filteredResults
        )
          .map((index) => [
            queryResult?.[index]?.["FileLocation"],
            queryResult?.[index]?.["AD OUTPUT FILE"],
          ])
          .filter(
            (item) =>
              !filteredColumns.some(
                (filteredItem) => filteredItem?.["FileLocation"] === item[0]
              )
          )
          .flat();
        const deDuplicatedArray = [...new Set(selectedRows)];
        console.log(deDuplicatedArray);
        setSelectedItems(deDuplicatedArray);
        setSelectedRowData(deDuplicatedArray);
      }
    }
    setSelectAll(!selectAll);
  };

  const handleCheckboxChange = (cid, index, adFileLocation) => {
    if (
      formData.transtype === "BillExtract" ||
      formData.transtype === "GoodsAndServicesEntries" ||
      formData.transtype === "ItemPreferences" ||
      formData.transtype === "ItemMaster" ||
      formData.transtype === "PurchaseOrder" ||
      formData.transtype === "VendorMaster" ||
      formData.transtype === "VendorPreferences" ||
      formData.transtype === "Payment" ||
      formData.transtype === "VendorAdvancePayment" ||
      formData.transtype === "PettyCash"
    ) {
      console.log(cid);
      const selected = [...selectedItems];
      if (selected?.includes(cid)) {
        const filteredSelected = selected.filter((item) => item !== cid);
        setSelectedItems(filteredSelected);
        setSelectedRowData(filteredSelected);
      } else {
        setSelectedItems([...selected, cid]);
        setSelectedRowData([...selected, cid]);
      }
      setWarningMessage("");
    } else {
      console.log(cid, index);
      const selected = [...selectedItems];
      if (selected?.includes(cid) && selected?.includes(index)) {
        const filteredSelected = selected.filter(
          (item) => item !== cid && item !== index
        );
        setSelectedItems(filteredSelected);
        setSelectedRowData(filteredSelected);
      } else {
        setSelectedItems([...selected, cid, index]);
        setSelectedRowData([...selected, cid, index]);
      }
      setWarningMessage("");
    }
  };

  const handleReset = () => {
    setFormData({
      transtype: "",
      company: "",
      email: "",
      transstatus: "",
    });
    var currentDate = moment();
    var firstDay = currentDate.startOf("month").format("YYYY-MM-DD");
    var lastDay = currentDate.endOf("month").format("YYYY-MM-DD");
    setFormData((prev) => {
      return { ...prev, fromDate: firstDay, toDate: lastDay };
    });
    setSelectedItems([]);
    setSelectedRowData([]);
    setSelectAll(false);
    setQueryResult([]);
    setLoading(false);
    setWarningMessage("");
    setShowError(false);
    setYear("");
    setMonth("");
  };

  const handleApproval = (Status) => {
    if (Status === "Rejected") {
      setApprovalStatus(Status);
      setShowModal(true);
    } else {
      processApproval(Status, null);
    }
  };

  const processApproval = (Status, reason) => {
    dispatch(showLoader());
    console.log("REJ");
    setDisableBtn(true);
    const id = companyDetails.filter(
      (company) => company.orgname === formData.company
    );
    const companyid =
      id.length > 0
        ? id.map((company) => company.orgid)
        : UserInputdetails.orgId;
    console.log("ID", companyid);

    let selectedActivities = [];
    let RowData = [];

    if (
      formData.transtype === "BillExtract" ||
      formData.transtype === "GoodsAndServicesEntries" ||
      formData.transtype === "ItemPreferences" ||
      formData.transtype === "ItemMaster" ||
      formData.transtype === "PurchaseOrder" ||
      formData.transtype === "VendorMaster" ||
      formData.transtype === "VendorPreferences" ||
      formData.transtype === "Payment" ||
      formData.transtype === "VendorAdvancePayment" ||
      formData.transtype === "PettyCash"
    ) {
      selectedActivities = queryResult
        .filter((item) => selectedItems?.includes(item["createdid"]))
        .map(
          (item) =>
            (item["ytapproveactivitycode"]?.includes(".0") &&
              item["ytapproveactivitycode"].replace(".0", "")) ||
            item["aactivitycd"] ||
            item["ytapproveactivitycode"]
        )
        .filter((value) => value)
        .flatMap((value) => value.split(","))
        .filter((value, index, self) => self.indexOf(value) === index);
      console.log("ACT", selectedActivities);
    } else {
      selectedActivities = queryResult
        .filter((item) => selectedItems?.includes(item.FileLocation))
        .map((item) =>
          Status === "Approved"
            ? item["ytapproveactivitycode"]
            : item["aactivitycd"]
        )
        .filter((value) => value)
        .flatMap((value) => value.split(","))
        .filter(
          (value, index, self) => self.indexOf(value) === index && value !== ""
        );
    }

    RowData = selectedRowData
      .flatMap((value) => value.split(","))
      .filter((value) => value !== "");
    console.log("LOCATION", RowData);

    const requestParams = {
      s3FilePaths: RowData,
      activityCode: selectedActivities,
      Status,
      orgId: companyid,
      type: formData.transtype,
      reason: reason,
      str: allActivityCodes.split(","),
      Module: localStorage.getItem("module"),
    };
    console.log("REQPARAMS", requestParams);

    setLoading(true);
    setShowError(false);

    postRequest(`api/edureka/bulkApprovalStatusUpdate`, requestParams)
      .then((response) => {
        console.log(response);

        if (response.type === "success") {
          handleSubmit();
          setSelectedItems([]);
          setSelectedRowData([]);
          setSelectAll(false);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setDisableBtn(false);
        dispatch(hideLoader());
      });
  };

  const handleScroll = () => {
    const isCloseToBottom =
      window.innerHeight + window.scrollY >= document.body.offsetHeight;
    setShowScrollButton(isCloseToBottom);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToBottom = () => {
    window.scrollTo({
      top: document.body.scrollHeight,
      behavior: "smooth",
    });
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleDocument = async (item) => {
    try {
      const id = companyDetails.filter(
        (company) => company.orgname === formData.company
      );
      const companyid =
        id.length > 0
          ? id.map((company) => company.orgid)
          : UserInputdetails.orgId;

      localStorage.setItem(
        "api",
        `api/edureka/approveJson?module=${localStorage.getItem(
          "module"
        )}&screenName=${formData.transtype
        }&activitycode=${allActivityCodes}&id=${item["createdid"]}&lde=${((formData.transtype === "ItemMaster" ||
          formData.transtype === "VendorMaster") &&
          "NoLDE") ||
        companyid
        }`
      );
      window.open(
        `/Dynamic_Forms?token=${formData.transtype}&action=edit&orgId=${((formData.transtype === "ItemMaster" ||
          formData.transtype === "VendorMaster") &&
          "NoLDE") ||
        companyid
        }&docId=${item["createdid"]}`,
        "_blank"
      );
      // const response = await postRequest(
      //   `api/edureka/approveJson?module=${localStorage.getItem(
      //     'module'
      //   )}&screenName=${
      //     formData.transtype
      //   }&activitycode=${allActivityCodes}&id=${
      //     item['createdid']
      //   }&lde=${companyid}`
      // )
      // if (response && response.res && response.res.data) {
      //   console.log(response.res.data)
      //   setSearchJSON(response.res.data)
      //   setRedirectBill(true)
      // } else {
      //   setRedirectBill(false)
      // }
    } catch (error) {
      console.error("Error fetching the data", error);
      setRedirectBill(false); // Set to false if an error occurs
    }
  };

  const toggleFormVisibility = () => {
    setIsFormVisible(!isFormVisible);
  };

  const handleModalSubmit = () => {
    processApproval(approvalStatus, rejectionReason);
    setShowModal(false);
    setRejectionReason(""); // clear rejection reason after use
  };

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed, so add 1
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}/${month}/${day}`;
  };

  const handleCSVDownload = () => {
    const now = new Date().toLocaleString();

    // Filter only selected items that have not been downloaded
    const itemsToDownload = filteredResults.filter((item) => {
      const downloadInfo = downloadedItems[item["createdid"]] || {};
      return (
        selectedItems?.includes(item["FileLocation"]) &&
        downloadInfo.downloaded === false
      );
    });

    if (itemsToDownload.length === 0) {
      alert("No rows selected or selected rows have already been downloaded.");
      return; // Prevent download if no valid rows
    }

    // Select only the necessary columns for the CSV
    const selectedColumns = itemsToDownload.map((item) => [
      item["IorN"],
      item["createdid"],
      item["PartyAcNumber"],
      item["ThisBillPymt"] ? Number(item["ThisBillPymt"]).toFixed(2) : "0.00",
      item["PartyName"],
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      item["createdid"],
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      formatDate(new Date()),
      "",
      item["PartyIFSCCode"],
      item["PartyBankName"],
      "",
      "payment.advices@edureka.co",
    ]);

    setcdata(selectedColumns);

    // Update the downloaded Status for the items being downloaded
    const updatedDownloadedItems = { ...downloadedItems };
    itemsToDownload.forEach((item) => {
      updatedDownloadedItems[item["createdid"]] = {
        downloaded: true,
        timestamp: now,
      };
    });

    setDownloadedItems(updatedDownloadedItems);

    // Call the API to save the updated download Status
    postRequest(`api/edureka/datenandtime`, updatedDownloadedItems)
      .then((response) => {
        console.log("Download timestamps updated successfully:", response);
      })
      .catch((err) =>
        console.error("Error updating download timestamps:", err)
      );
  };

  useEffect(() => {
    const filteredData = queryResult.filter(
      (item) =>
        (item.status === formData.transstatus ||
          formData.transstatus === null ||
          formData.transstatus === "" ||
          formData.transstatus === undefined) &&
        // (item.Name === formData.name ||
        //   formData.name === null ||
        //   formData.name === "" ||
        //   formData.name === undefined) &&
        (item["Link Ref"] === formData.linkref ||
          formData.linkref === null ||
          formData.linkref === "" ||
          formData.linkref === undefined) &&
        (item.activitystatus === formData.activitystatus ||
          formData.activitystatus === null ||
          formData.activitystatus === "" ||
          formData.activitystatus === undefined) &&
        (item.createdid === formData.createdid ||
          formData.createdid === null ||
          formData.createdid === "" ||
          formData.createdid === undefined)
    );
    setFilteredResults(filteredData);
    setPage(0);
    console.log(filteredData, formData);
  }, [
    formData.transstatus,
    formData.createdid,
    formData.name,
    formData.activitystatus,
    formData.linkref,
  ]);

  const filteredSecondTableResults = queryResult.filter((item) => {
    const downloadInfo = downloadedItems[item["createdid"]] || {};
    // Filter by CSV Downloaded based on formData.csvDownloaded
    const matchesCSVDownloaded = formData.csvDownloaded
      ? formData.csvDownloaded === "Yes"
        ? downloadInfo.downloaded === true
        : downloadInfo.downloaded === false
      : true;
    // Add any other filtering logic, such as transstatus or transtype here if needed
    const matchesTransStatus = formData.transstatus
      ? formData.transtype === "Payment" ||
        formData.transtype === "VendorAdvancePayment" ||
        formData.transtype === "PettyCash"
        ? item["activitystatus"] === formData.transstatus
        : item["status"] === formData.transstatus
      : true;
    return matchesCSVDownloaded && matchesTransStatus;
  });

  const getPaymentCSV = async (filename) => {
    try {
      const id = companyDetails.filter(
        (item) => item.orgname === formData.company
      );
      const orgid =
        id.length > 0 ? id.map((item) => item.orgid) : UserInputdetails.orgId;

      let { res } = await getRequest(
        `api/vr2/getPaymentCSV?filename=${encodeURIComponent(
          filename
        )}&orgid=${orgid}`
      );
      if (res.status === "success") {
        const base64Data = res.data.file;
        const byteCharacters = atob(base64Data);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const blob = new Blob([new Uint8Array(byteNumbers)], {
          type: "text/csv",
        });

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `${filename}.csv`;
        link.click();
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleCombainCSV = async () => {
    try {
      const id = companyDetails.filter(
        (item) => item.orgname === formData.company
      );
      const orgid =
        id.length > 0 ? id.map((item) => item.orgid) : UserInputdetails.orgId;
      let filenames = selectedItems.map(
        (item) =>
          `Payment_${filteredResults.find((i) => i["createdid"] === item)?.[
          "Payment File"
          ]
          }`
      );

      const results = await Promise.all(
        filenames.map(async (filename) => {
          let { res } = await getRequest(
            `api/vr2/getPaymentCSV?filename=${encodeURIComponent(
              filename
            )}&orgid=${orgid}`
          );
          if (res.status !== "success") return;

          const base64Data = res.data.file;
          const byteCharacters = atob(base64Data);
          return byteCharacters;
        })
      );

      let combainedCSV = "";
      results.forEach((csv, index) => {
        if (!csv) return;

        const dataOnly = csv;

        combainedCSV +=
          (!combainedCSV.includes(dataOnly.trim() + "\n") &&
            dataOnly.trim() + "\n") ||
          "";
        const blob = new Blob([combainedCSV], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `Payments_${moment().format(
          "YYYY-MM-DD_HH-mm-ss"
        )}.csv`;
        link.click();

        window.URL.revokeObjectURL(url);
      });
    } catch (error) {
      console.log(error);
    }
  };

  if (redirectBill) {
    return (
      <VR2_Forms
        screenName={formData.transtype}
        screenAction={"edit"}
        From_SearchJSON={searchJSON}
        onBack={() => setRedirectBill(false)}
      />
    );
  }

  const toggleSortOrder = () => {
    setSortOrder((prevOrder) => (prevOrder === "asc" ? "desc" : "asc"));
  };

  // Sort filteredSecondTableResults within the render
  const sortedResults = [...filteredSecondTableResults].sort((a, b) => {
    const docA = a.accountingdocnumber || ""; // Default to empty string if undefined
    const docB = b.accountingdocnumber || ""; // Default to empty string if undefined
    if (sortOrder === "asc") {
      return docA.localeCompare(docB, undefined, { numeric: true });
    } else {
      return docB.localeCompare(docA, undefined, { numeric: true });
    }
  });

  return (
    <>
      <Box mb={2}>
        <Accordion defaultExpanded>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6">Search Bulk Approvals</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={2}>
              <Grid item xs={1} sm={2} md={3}>
                <Autocomplete
                  options={companyName}
                  value={formData.company}
                  onChange={(e, newValue) => handleChange("company", newValue)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Organization Name"
                      variant="outlined"
                      size="small"
                    />
                  )}
                />
              </Grid>

              <Grid item xs={1} sm={2} md={2}>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <DatePicker
                    label="ForPrdFrom"
                    value={formData.fromDate}
                    views={["day", "month", "year"]}
                    onChange={(newValue) =>
                      handleChange(
                        "fromDate",
                        moment(newValue).format("YYYY-MM-DD")
                      )
                    }
                    renderInput={(params) => (
                      <TextField fullWidth size="small" {...params} />
                    )}
                  />
                </LocalizationProvider>
              </Grid>

              <Grid item xs={1} sm={2} md={2}>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <DatePicker
                    label="ForPrdTo"
                    value={formData.toDate}
                    views={["day", "month", "year"]}
                    onChange={(newValue) =>
                      handleChange(
                        "toDate",
                        moment(newValue).format("YYYY-MM-DD")
                      )
                    }
                    renderInput={(params) => (
                      <TextField fullWidth size="small" {...params} />
                    )}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={1} sm={2} md={2}>
                <Autocomplete
                  options={TransactionTypes}
                  value={formData.transtype}
                  onChange={(e, newValue) =>
                    handleChange("transtype", newValue || "")
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Transaction Types"
                      variant="outlined"
                      size="small"
                    />
                  )}
                />
              </Grid>
              <Grid item>
                <Button
                  onClick={handleSubmit}
                  variant="contained"
                  color="success"
                >
                  Submit
                </Button>
              </Grid>
              <Grid item>
                <Button
                  onClick={handleReset}
                  style={{ marginLeft: "10px" }}
                  variant="contained"
                  color="error"
                >
                  Reset
                </Button>
              </Grid>
              {queryResult.length > 0 && (
                <>
                  {((formData.transtype === "VendorMaster" ||
                    formData.transtype === "ItemMaster" ||
                    formData.transtype === "VendorPreferences" ||
                    formData.transtype === "ItemPreferences") && (
                      <Grid item xs={1} sm={2} md={3}>
                        <Autocomplete
                          options={Name || []}
                          value={formData.name || null}
                          onChange={(e, newValue) =>
                            handleChange("name", newValue || "")
                          }
                          getOptionLabel={(option) =>
                            typeof option === "string" ? option : ""
                          }
                          isOptionEqualToValue={(option, value) =>
                            option === value
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Name"
                              variant="outlined"
                              size="small"
                            />
                          )}
                        />
                      </Grid>
                    )) ||
                    ((formData.transtype === "PurchaseOrder" ||
                      formData.transtype === "BillExtract" ||
                      formData.transtype === "GoodsAndServicesEntries") && (
                        <Grid item xs={1} sm={2} md={3}>
                          <Autocomplete
                            options={LinkRef || []}
                            value={formData.linkref || null}
                            onChange={(e, newValue) =>
                              handleChange("linkref", newValue || "")
                            }
                            getOptionLabel={(option) =>
                              typeof option === "string" ? option : ""
                            }
                            isOptionEqualToValue={(option, value) =>
                              option === value
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Link Ref"
                                variant="outlined"
                                size="small"
                              />
                            )}
                          />
                        </Grid>
                      ))}
                  <Grid item xs={1} sm={2} md={3}>
                    <Autocomplete
                      options={ActivityStatus || []}
                      value={
                        formData.activitystatus ? formData.activitystatus : null
                      }
                      onChange={(e, newValue) =>
                        handleChange("activitystatus", newValue || "")
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Activity Status"
                          variant="outlined"
                          size="small"
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={1} sm={2} md={3}>
                    <Autocomplete
                      options={createdIds}
                      value={formData.createdid ? formData.createdid : null}
                      onChange={(e, newValue) =>
                        handleChange("createdid", newValue || "")
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Created ID"
                          variant="outlined"
                          size="small"
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={1} sm={2} md={3}>
                    <Autocomplete
                      options={statusOptions}
                      value={formData.transstatus}
                      onChange={(e, newValue) =>
                        handleChange("transstatus", newValue || "")
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Status"
                          variant="outlined"
                          size="small"
                        />
                      )}
                    />
                  </Grid>
                </>
              )}

              {selectedRowData.length > 0 &&
                (selectedStatus === "Rejected" ||
                  "Waiting For Approval" ||
                  "Approved") ? (
                <Grid item>
                  <Button
                    onClick={() => handleApproval("Approved")}
                    style={{ marginLeft: "10px" }}
                    color="secondary"
                    variant="contained"
                    disabled={
                      filteredResults.length === 0 ||
                      selectedItems.length === 0 ||
                      selectedItems
                        .map(
                          (item) =>
                            filteredResults.find((i) => i["createdid"] === item)
                              ?.activitystatus
                        )
                        .some((status) => status === "Approved") ||
                      disableBtn
                    }
                  >
                    Approve
                  </Button>
                </Grid>
              ) : null}
              {selectedRowData.length > 0 &&
                (selectedStatus === "Approved" || "Active") ? (
                <Grid item>
                  <Button
                    onClick={() => handleApproval("Rejected")}
                    style={{ marginLeft: "10px" }}
                    variant="contained"
                    color="error"
                    disabled={
                      filteredResults.length === 0 ||
                      selectedItems.length === 0 ||
                      selectedItems
                        .map(
                          (item) =>
                            filteredResults.find((i) => i["createdid"] === item)
                              ?.activitystatus
                        )
                        .some((status) => status === "Rejected") ||
                      disableBtn
                    }
                  >
                    Reject
                  </Button>
                </Grid>
              ) : null}
              {selectedRowData.length > 0 &&
                (formData.transtype === "Payment" ||
                  formData.transtype === "VendorAdvancePayment" ||
                  formData.transtype === "PettyCash") && (
                  <Grid item>
                    <Button
                      onClick={() => handleCombainCSV()}
                      style={{ marginLeft: "10px" }}
                      variant="contained"
                      color="secondary"
                      disabled={
                        filteredResults.length === 0 ||
                        selectedItems.length === 0 ||
                        selectedItems
                          .map(
                            (item) =>
                              filteredResults.find(
                                (i) => i["createdid"] === item
                              )?.activitystatus
                          )
                          .some((status) => status === "Rejected") ||
                        disableBtn
                      }
                    >
                      Combaine Csv
                    </Button>
                  </Grid>
                )}
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Box>
      <Dialog
        open={showModal}
        onClose={() => setShowModal(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Reason for Rejection</DialogTitle>
        <DialogContent>
          <Typography gutterBottom>
            Please enter the reason for rejection:
          </Typography>
          <TextField
            fullWidth
            variant="outlined"
            value={rejectionReason}
            onChange={(e) => setRejectionReason(e.target.value)}
            placeholder="Enter reason"
          />
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            disabled={!rejectionReason.trim() || rejectionReason.length === 0}
            onClick={handleModalSubmit}
          >
            Continue
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={() => setShowModal(false)}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
      {queryResult.length > 0 && (
        <Box
          align="right"
          sx={{
            m: 2,
            display: "flex",
            justifyContent: "flex-end",
            flexDirection: "row",
            gap: 2,
          }}
        >
          <>
            <Pagination
              count={Math.ceil(filteredResults.length / rowsPerPage)}
              page={page + 1}
              onChange={(event, newPage) => {
                handleChangePage(event, newPage - 1);
              }}
              variant="outlined"
              shape="rounded"
              showFirstButton
              showLastButton
            />
            &nbsp;
            <CSVLink size="sm" filename="BulkApprovals.csv" data={queryResult}>
              <Button variant="contained" color="success">
                <GetAppIcon />
              </Button>
            </CSVLink>
          </>
        </Box>
      )}
      {(!loading &&
        queryResult.length &&
        formData.transtype === "BillExtract") ||
        formData.transtype === "GoodsAndServicesEntries" ||
        formData.transtype === "ItemPreferences" ||
        formData.transtype === "ItemMaster" ||
        formData.transtype === "PurchaseOrder" ||
        formData.transtype === "VendorMaster" ||
        formData.transtype === "Payment" ||
        formData.transtype === "VendorAdvancePayment" ||
        formData.transtype === "PettyCash" ||
        formData.transtype === "VendorPreferences" ? (
        <>
          <Grid container>
            <Grid item lg={pdfUrl ? 6 : 12}>
              <TableContainer component={Paper}>
                <Table size="small" stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell padding="checkbox">
                        <Checkbox
                          disabled={filteredResults.length === 0}
                          checked={selectAll}
                          onClick={handleSelectAll}
                        />
                      </TableCell>
                      {(formData.transtype === "BillExtract" && (
                        <TableCell>Attachment</TableCell>
                      )) ||
                        ""}
                      {filteredResults.length > 0 &&
                        Object.keys(filteredResults[0]).map((key, index) => (
                          <TableCell key={index}>{key}</TableCell>
                        ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {(filteredResults.length > 0 &&
                      (rowsPerPage > 0
                        ? filteredResults.slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        : filteredResults
                      ).map((item, index) => (
                        <TableRow
                          key={index}
                          hover
                          selected={selectedItems?.includes(item["createdid"])}
                        >
                          <TableCell padding="checkbox">
                            <Checkbox
                              checked={selectedItems?.includes(
                                item["createdid"]
                              )}
                              onClick={() =>
                                handleCheckboxChange(
                                  item["createdid"],
                                  selectedStatus
                                )
                              }
                            />
                          </TableCell>
                          {(formData.transtype === "BillExtract" && (
                            <TableCell>
                              <IconButton
                                onClick={() => getPdf(item["FileLocation"])}
                              >
                                <PictureAsPdfIcon
                                  style={{
                                    fontSize: "20px",
                                    color:
                                      activePdf === item["FileLocation"]
                                        ? "red"
                                        : "black",
                                  }}
                                />
                              </IconButton>
                            </TableCell>
                          )) ||
                            ""}
                          {filteredResults.length > 0 &&
                            Object.keys(filteredResults[0]).map((key, idx) => (
                              <TableCell>
                                {key === "createdid" ? (
                                  <Button
                                    variant="text"
                                    onClick={() => handleDocument(item)}
                                  >
                                    {item[key]}
                                  </Button>
                                ) : key === "Payment File" &&
                                  (formData.transtype === "Payment" ||
                                    formData.transtype ===
                                    "VendorAdvancePayment" ||
                                    formData.transtype === "PettyCash") ? (
                                  <Tooltip title={item[key]}>
                                    <IconButton
                                      disabled={
                                        item["activitystatus"] != "Approved"
                                      }
                                      onClick={() =>
                                        getPaymentCSV(`Payment_${item[key]}`)
                                      }
                                      color="success"
                                    >
                                      <GetApp />
                                    </IconButton>
                                  </Tooltip>
                                ) : (
                                  item[key]
                                )}
                              </TableCell>
                            ))}
                        </TableRow>
                      ))) || (
                        <TableRow>
                          <TableCell
                            colSpan={
                              queryResult.length > 0 &&
                              Object.keys(queryResult[0]).length
                            }
                            sx={{ p: 5 }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                height: "100%",
                              }}
                            >
                              <Alert severity="error" variant="outlined">
                                No matching records found. Please adjust your
                                search criteria.
                              </Alert>
                            </Box>
                          </TableCell>
                        </TableRow>
                      )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
            <Grid
              item
              lg={6}
              sx={{
                position: "sticky",
              }}
            >
              {pdfUrl && (
                <Drawer
                  anchor="right"
                  open={Boolean(pdfUrl)}
                  onClose={closeModal}
                  variant="persistent"
                  ModalProps={{
                    keepMounted: true,
                    hideBackdrop: true,
                  }}
                  PaperProps={{
                    sx: {
                      width: "100%",
                      position: "sticky",
                      marginTop: "64px",
                    },
                  }}
                >
                  <IconButton
                    onClick={closeModal}
                    sx={{
                      position: "absolute",
                      right: 0,
                      color: "white",
                    }}
                  >
                    <CloseIcon sx={{ fontSize: 24 }} />
                  </IconButton>
                  <iframe
                    title="pdf-viewer"
                    style={{
                      width: "100%",
                      height: "70vh",
                      border: "none",
                    }}
                    src={pdfUrl}
                  />
                </Drawer>
              )}
            </Grid>
          </Grid>
        </>
      ) : null}

      {/* Third Table (For Other Transaction TransactionTypes) */}
      {!loading &&
        queryResult.length &&
        formData.transtype !== "BillExtract" &&
        formData.transtype !== "GoodsAndServicesEntries" &&
        formData.transtype !== "ItemPreferences" &&
        formData.transtype !== "ItemMaster" &&
        formData.transtype !== "PurchaseOrder" &&
        formData.transtype !== "VendorMaster" &&
        formData.transtype !== "VendorPreferences" &&
        formData.transtype !== "Payment" &&
        formData.transtype !== "VendorAdvancePayment" &&
        formData.transtype !== "PettyCash" ? (
        <Box width="100%">
          <Box
            display="flex"
            flexDirection="row"
            className={`contin ${pdfUrl ? "split" : ""}`}
          >
            <Box flex={pdfUrl ? 0.7 : 1} className="left-panel">
              <TableContainer component={Paper}>
                <Table size="small" stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <Checkbox
                          checked={selectAll}
                          onClick={handleSelectAll}
                        />
                      </TableCell>
                      {sortedResults.length > 0 &&
                        Object.keys(sortedResults[0]).map((key, idx) => (
                          <TableCell key={idx}>{key}</TableCell>
                        ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {(sortedResults.length > 0 &&
                      sortedResults.map((item, index) => {
                        return (
                          <TableRow
                            key={index}
                            style={{
                              backgroundColor: selectedItems?.includes(
                                item["FileLocation"]
                              )
                                ? "#a0d3ff"
                                : "transparent",
                            }}
                          >
                            <TableCell>
                              <Checkbox
                                checked={selectedItems?.includes(
                                  item["FileLocation"]
                                )}
                                onClick={() =>
                                  handleCheckboxChange(
                                    item["FileLocation"],
                                    item["AD OUTPUT FILE"]
                                  )
                                }
                              />
                            </TableCell>
                            {sortedResults.length > 0 &&
                              Object.keys(sortedResults[0]).map((key, idx) => (
                                <TableCell key={idx}>{item[key]}</TableCell>
                              ))}
                          </TableRow>
                        );
                      })) || (
                        <TableRow>
                          <TableCell
                            colSpan={Object.keys(sortedResults[0]).length}
                            sx={{ p: 5 }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                height: "100%",
                              }}
                            >
                              <Alert severity="error" variant="outlined">
                                No matching records found. Please adjust your
                                search criteria.
                              </Alert>
                            </Box>
                          </TableCell>
                        </TableRow>
                      )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Box>
        </Box>
      ) : null}

      {/* {!loading && queryResult.length && formData.transtype === 'Payment' ? (
        <Box width='100%'>
          <Box
            display='flex'
            flexDirection='row'
            className={`contin ${pdfUrl ? 'split' : ''}`}
          >
            <Box flex={pdfUrl ? 0.7 : 1} className='left-panel'>
              <TableContainer component={Paper}>
                <Table size='small' stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <Checkbox
                          checked={selectAll}
                          onClick={handleSelectAll}
                        />
                      </TableCell>
                      {queryResult.length > 0 &&
                        Object.keys(queryResult[0]).map((key, idx) => (
                          <TableCell key={idx}>{key}</TableCell>
                        ))}
                      {filteredSecondTableResults.some(
                        item => item['activitystatus'] === 'Active'
                      ) && (
                        <>
                          <TableCell>CSV Downloaded</TableCell>
                          <TableCell>Download Timestamp</TableCell>
                        </>
                      )}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {(filteredSecondTableResults.length > 0 &&
                      filteredSecondTableResults.map((item, index) => {
                        const downloadInfo =
                          downloadedItems[item['createdid']] || {}
                        return (
                          <TableRow
                            key={index}
                            style={{
                              backgroundColor: selectedItems?.includes(
                                item['FileLocation']
                              )
                                ? '#a0d3ff'
                                : 'transparent'
                            }}
                          >
                            <TableCell>
                              <Checkbox
                                checked={selectedItems?.includes(
                                  item['FileLocation']
                                )}
                                onClick={() =>
                                  handleCheckboxChange(
                                    item['FileLocation'],
                                    item['AD OUTPUT FILE']
                                  )
                                }
                              />
                            </TableCell>
                            {filteredSecondTableResults.length > 0 &&
                              Object.keys(filteredSecondTableResults[0]).map(
                                (key, idx) => (
                                  <TableCell key={idx}>{item[key]}</TableCell>
                                )
                              )}
                            {item['activitystatus'] === 'Active' && (
                              <>
                                <TableCell>
                                  {downloadInfo.downloaded ? 'Yes' : 'No'}
                                </TableCell>
                                <TableCell>
                                  {downloadInfo.timestamp || '-'}
                                </TableCell>
                              </>
                            )}
                          </TableRow>
                        )
                      })) || (
                      <TableRow>
                        <TableCell
                          colSpan={
                            filteredSecondTableResults.length &&
                            Object.keys(filteredSecondTableResults[0])?.length
                          }
                          sx={{ p: 5 }}
                        >
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              height: '100%'
                            }}
                          >
                            <Alert severity='error' variant='outlined'>
                              No matching records found. Please adjust your search criteria.
                            </Alert>
                          </Box>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Box>
        </Box>
      ) : null} */}
      <div style={{ position: "fixed", bottom: 20, right: 20, zIndex: 999 }}>
        {showScrollButton ? (
          <>
            <Button size="sm" onClick={scrollToTop}>
              <NorthIcon />
            </Button>
            <br />
            <br />
            <Button size="sm" onClick={scrollToBottom}>
              <SouthIcon />
            </Button>
          </>
        ) : null}
      </div>
      {showError && <div className="center-screen">{warningMessage}</div>}
    </>
  );
};
export default BulkApprovals;
